import ApiService from 'Services/ApiService'

export default {
    list(query) {
        return ApiService.get(`/default-issues`, query)
    }
}
